import moveItemsBasedOnNodeIds from '../actions/actionCreators/moveItemsBasedOnNodeIds';
import moveItemsFromItemIds from '../actions/move/moveItemsFromItemIds';
import { listViewStore } from 'owa-mail-list-store';
import getItemIdsToShowFromNodeIds from 'owa-mail-store/lib/selectors/getItemIdsToShowFromNodeIds';
import { orchestrator } from 'satcheljs';
import { selectNextItemPart } from 'owa-mail-actions/lib/mailListSelectionActions';

export default orchestrator(moveItemsBasedOnNodeIds, actionMessage => {
    const itemIds = getItemIdsToShowFromNodeIds(actionMessage.nodeIds);
    const tableView = listViewStore.tableViews.get(actionMessage.tableViewId);

    selectNextItemPart(listViewStore.expandedConversationViewState.expandedRowKey, tableView);

    moveItemsFromItemIds(
        itemIds,
        actionMessage.destinationFolderId,
        tableView,
        actionMessage.actionSource
    );
});
